import { KeyboardEvent, ReactNode } from 'react';

import { Label, RootContainer } from './styled';

type PeriodButtonProps = {
  children: ReactNode;
  isActive: boolean;
  onSelect: () => void;
};

export const PeriodTab = ({ children, isActive, onSelect }: PeriodButtonProps) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect();
    }
  };

  return (
    <RootContainer
      aria-pressed={isActive}
      data-testid="period-tab-root-container"
      isActive={isActive}
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
    >
      <Label isActive={isActive}>{children}</Label>
    </RootContainer>
  );
};
